<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">

                    <div class="box-header with-border">
                        <div class="row">
                            <div class="col-sm-9">
                                <h3 class="box-title">
                                    <b>Marcação de Atendimentos</b>
                                </h3>
                            </div>

                            
							<!-- <div v-if="distribuicoes.length > 1" class="col-sm-3">
                                <select @change="mudarDistribuicao()" v-model="distribuicaoId" class="form-control" name="" id="">
                                    <option v-for="(item, index) in distribuicoes" :key="index" :value="item.id">Solicitar no mês de {{ item.data_competencia | mesPorExtenso }}</option>
                                </select>
                            </div> -->
                            
                        </div>

                        
                        <!-- <div class="box-body" style="font-size: 14px; float:right">
                          <strong>ATENÇÃO!</strong>
                          <p>
                            Para marcação das vagas de Outubro, selecione <strong>OUTUBRO</strong> na caixa de seleção.<br/>
                            Para marcação das vagas de Novembro, selecione <strong>NOVEMBRO</strong>.
                          </p>
                        </div> -->
                       
                </div>

                    <div class="box-body">
                        <!-- <form action=""> -->
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for>Unidade solicitante</label>
                                    <label v-shortkey="['alt', '1']" @shortkey="focoUnidades()" class="labe-telca-atalho">alt + 1</label>
                                    <v-select ref="selectUnidade" @change="limparProcedimentos()" v-model="contratoSolicitanteSelecionado" placeholder="SELECIONE A UNIDADE SOLICITANTE..." label="nome" :options="unidades"></v-select>
                                </div>
                            </div>
                        </div>
                        <!-- <pre>{{ unidades }}</pre> -->
                        <div class="row" v-if="contratoSolicitanteSelecionado">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerPaciente }" for>Nome do paciente</label>
                                    <label class="labe-telca-atalho">alt + 2</label>
                                    <select-paciente
                                        ref="btnPaciente"
                                        :nome-paciente-recuperado="dados.paciente.nome"
                                        @limpar="(historico = {}), (historicoAntigo = {})"
                                        :cidadeUnidadeSolicitante="contratoSolicitanteSelecionado.unidade.cidade_id"
                                        :unidadeSolicitante="contratoSolicitanteSelecionado.unidade"
                                        :show-text-danger-paciente="showTextDangerPaciente"
                                        @setPacienteSelecionado="
                                            paciente => {
                                                setPacienteSelecionado(paciente);
                                            }
                                        "
                                    ></select-paciente>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group" :class="{ 'has-error': showTextDangerPaciente }">
                                    <label for>CNS do paciente</label>
                                    <input v-model="this.dados.paciente.cartao_sus" disabled type="text" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group" :class="{ 'has-error': showTextDangerPaciente }">
                                    <label for>Município do paciente</label>
                                    <input v-model="this.dados.paciente.cidade.nome" disabled type="text" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerProfissional }" for>Profissional solicitante</label>
                                    <label class="labe-telca-atalho">alt + 3</label>
                                    <select-profissional
                                        :nome-profissional-recuperado="dados.profissionalSolicitante.nome"
                                        :unidade-solicitante-selecionada="contratoSolicitanteSelecionado.unidade"
                                        ref="btnProfissional"
                                        :show-text-danger-profissional="showTextDangerProfissional"
                                        @setProfissionalSelecionado="
                                            profissional => {
                                                setProfissionalSelecionado(profissional);
                                            }
                                        "
                                    ></select-profissional>
                                </div>
                            </div>
                        </div>
                        <historicos :show-info="showInfo" @showModalNaoRealizados="showModalNaoRealizados = true" ref="historicos" :pacienteId="dados.paciente.id"></historicos>
                        <div class="box" :class="{ 'box-danger': showTextDangerProcedimento }">
                            <div class="box-header with-border">
                                <h3 class="box-title" :class="{ 'erro-validacao': showTextDangerProcedimento }">Procedimentos da solicitação</h3>
                                <div class="box-tools pull-right">
                                    <button v-shortkey="['alt', '4']" @shortkey="mostrarModalProcedimento()" :class="{ 'btn-danger': showTextDangerProcedimento }" @click="mostrarModalProcedimento()" type="button" class="btn btn-sm"><i class="fa fa-plus"></i> Adicionar</button>
                                    <label class="labe-telca-atalho">alt + 4</label>
                                </div>
                            </div>
                            <div class="box-body">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Quantidade</th>
                                            <th>Código</th>
                                            <th>Nome</th>
                                            <th>Consulta</th>
                                            <th width="1%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in dados.procedimentos" :key="index">
                                            <td>{{ item.procedimento.quantidade }}</td>
                                            <td>{{ item.procedimento.codigo }}</td>
                                            <td>{{ item.procedimento.nome }}</td>
                                            <td>{{ item.procedimento.tipo_consulta | tipo_consulta }}</td>
                                            <td>
                                                <button @click="removerProcedimento(index)" class="btn btn-sm btn-danger">
                                                    <span class="fa fa-trash"></span>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- <pre>
							{{$store.state.solicitacao.dadosResolucao}}
						</pre> -->
                        <div class="box">
                            <div class="box-header with-border">
                                <h3 class="box-title">Diagnósticos indicados</h3>
                                <div class="box-tools pull-right">
                                    <button ref="btnAdicionarDiagnostico" v-shortkey="['alt', '5']" @shortkey="showModalAddDiagnosticos = true" @click="showModalAddDiagnosticos = true" type="button" class="btn btn-sm btn-default"><i class="fa fa-plus"></i> Adicionar</button>
                                    <label class="labe-telca-atalho">alt + 5</label>
                                </div>
                            </div>
                            <div class="box-body">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Código CID</th>
                                            <th>Nome</th>
                                            <th width="1%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(diagnostico, index) in dados.diagnosticos" :key="index">
                                            <td>{{ diagnostico.cid }}</td>
                                            <td>{{ diagnostico.nome }}</td>
                                            <td>
                                                <button @click="removerDiagnostico(index)" class="btn btn-sm btn-danger">
                                                    <span class="fa fa-trash"></span>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button @click="resolver" v-shortkey="['alt', 'r']" @shortkey="resolver" title="pressione alt + r para resolver" class="btn btn-primary pull-right"><span class="fa fa-arrow-right"></span> Resolver</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-add-procedimentos
            :contrato-solicitante-selecionado="contratoSolicitanteSelecionado"
            :profissional-solicitante-selecionado="dados.profissionalSolicitante"
            :show="showModalAddProcedimentos"
            @close="(showModalAddProcedimentos = false), (focusAdicionarDiagnositico = true)"
            @incluirProcedimentoSelecionado="
                contratoProcedimento => {
                    incluirProcedimentoSelecionado(contratoProcedimento);
                }
            "
        ></modal-add-procedimentos>
        <modal-quantidade-procedimentos
            :show="showModalQuantidadeProcedimentos"
            :contrato-procedimento="contratoProcedimentoTemp"
            @close="showModalQuantidadeProcedimentos = false"
            @addProcedimentoSelecionado="
                contratoProcedimento => {
                    addProcedimentoSelecionado(contratoProcedimento);
                }
            "
        ></modal-quantidade-procedimentos>
        <modal-add-diagnosticos
            :show="showModalAddDiagnosticos"
            @close="showModalAddDiagnosticos = false"
            @addDiagnosticoSelecionado="
                diagnostico => {
                    addDiagnosticoSelecionado(diagnostico);
                }
            "
        ></modal-add-diagnosticos>
        <modal-nao-realizados
            :regulacao="false"
            @selecionarProfissional="
                showModalNaoRealizados = false;
                $refs.btnProfissional.abrirModal();
            "
            :nao-realizados="naoRealizados"
            :show="showModalNaoRealizados"
            @close="showModalNaoRealizados = false"
        ></modal-nao-realizados>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import selectPaciente from "../../cadastros/pacientes/selectPaciente";
import selectProfissional from "../../cadastros/profissionais/selectProfissional";
import modalAddProcedimentos from "./modalAddProcedimentos";
import modalQuantidadeProcedimentos from "./modalQuantidadeProcedimentos";
import modalNaoRealizados from "../comuns/modalNaoRealizados";
import historicos from "./historicos";
import modalAddDiagnosticos from "./modalAddDiagnosticos";
export default {
    filters: {
        tipo_consulta: function(val) {
            if (val == 0) {
                return "Primeira";
            } else if (val == 1) {
                return "Retorno";
            } else if (val == 2) {
                return "Local";
            }
        }
    },
    components: {
        selectPaciente,
        selectProfissional,
        modalAddProcedimentos,
        modalQuantidadeProcedimentos,
        modalAddDiagnosticos,
        historicos,
        modalNaoRealizados
    },
    data: () => ({
        showModalNaoRealizados: false,
        showInfo: false,
        showModalAddDiagnosticos: false,
        showModalAddProcedimentos: false,
        showModalQuantidadeProcedimentos: false,
        showTextDangerPaciente: false,
        showTextDangerProcedimento: false,
        showTextDangerProfissional: false,
        focusAdicionarDiagnositico: false,
        unidades: [],
        profissionais: [],
        naoRealizados: [],
        procedimentos: [],
        distribuicoes: [],
        distribuicaoId: "",
        contratoSolicitanteSelecionado: null,
        contratoProcedimentoTemp: {
            procedimento: {
                codigo: "",
                nome: ""
            }
        },
        dados: {
            unidadeSolicitante: null,
            paciente: {
                nome: "",
                nome_mae: "",
                data_nascimento: "",
                rg: "",
                cartao_sus: "",
                cidade: {
                    nome: ""
                }
            },
            profissionalSolicitante: {
                nome: "",
                situacao: "",
                data_admissao: "",
                data_desligamento: "",
                data_nascimento: "",
                sexo: "",
                rg: "",
                orgao_emissor: "",
                uf_orgao_emissor: "",
                data_emissao: "",
                cpf: "",
                telefone: "",
                hora_inicial: "",
                hora_final: ""
            },
            diagnosticos: [],
            procedimentos: [],
            solicitacao_regulacao: false,
            dados_recuperados: false
        }
    }),
    mounted() {
        if (this.$store.state.solicitacao.dadosResolucao) {
            if (!this.$store.state.solicitacao.dadosResolucao.dados_recuperados) {
                this.$store.state.solicitacao.dadosResolucao = null;
            } else {
                this.dados = this.$store.state.solicitacao.dadosResolucao;
            }
        }
        this.getDistribuicoes();
        this.focoUnidades();
    },
    methods: {
        mudarDistribuicao() {
            this.contratoSolicitanteSelecionado = null;
            this.dados = this.estadoInicial();
        },
        estadoInicial() {
            let dados = {
                unidadeSolicitante: null,
                paciente: {
                    nome: "",
                    nome_mae: "",
                    data_nascimento: "",
                    rg: "",
                    cartao_sus: "",
                    cidade: {
                        nome: ""
                    }
                },
                profissionalSolicitante: {
                    nome: "",
                    situacao: "",
                    data_admissao: "",
                    data_desligamento: "",
                    data_nascimento: "",
                    sexo: "",
                    rg: "",
                    orgao_emissor: "",
                    uf_orgao_emissor: "",
                    data_emissao: "",
                    cpf: "",
                    telefone: "",
                    hora_inicial: "",
                    hora_final: ""
                },
                diagnosticos: [],
                procedimentos: [],
                solicitacao_regulacao: false,
                dados_recuperados: false
            };

            return dados;
        },
        getNaoRealizados() {
            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getNaoRealizados/` + this.dados.paciente.id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.naoRealizados = response.data;
                    if (this.naoRealizados.length > 0) {
                        this.showModalNaoRealizados = true;
                        this.showInfo = true;
                    } else {
                        this.showInfo = false;
                        this.$refs.btnProfissional.abrirModal();
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        // situacao(situacao) {
        //     switch (situacao) {
        //         case 1:
        //             return "EM ANALISE";
        //         case 2:
        //             return "APROVADA";
        //         case 3:
        //             return "CONFIRMADA";
        //         case 4:
        //             return "NEGADA";
        //         case 5:
        //             return "EM PERÍCIA";
        //         case 6:
        //             return "CANCELADA";
        //         case 7:
        //             return "REALIZADA";
        //         case 8:
        //             return "FALTA";
        //         case 9:
        //             return "EM SUPERVISÃO";
        //         case 10:
        //             return "SUPERVISIONADO";
        //         case 11:
        //             return "EM EXTRAPOLACAO";
        //         case 12:
        //             return "TFD";
        //         case 18:
        //             return "FALTA AUTOMÁTICA";
        //     }
        // },
        validar() {
            if (this.isEmpty(this.dados.paciente)) {
                this.showTextDangerPaciente = true;
            }

            if (this.isEmpty(this.dados.profissionalSolicitante)) {
                this.showTextDangerProfissional = true;
            }

            if (this.dados.procedimentos.length === 0) {
                this.showTextDangerProcedimento = true;
            }

            if (!this.showTextDangerPaciente && !this.showTextDangerProfissional && !this.showTextDangerProcedimento) {
                return true;
            }

            return false;
        },
        resolver() {
            if (this.validar()) {
                if (this.dados.paciente.cidade_id != this.contratoSolicitanteSelecionado.unidade.cidade_id && this.contratoSolicitanteSelecionado.unidade.paciente_outro_municipio != 1) {
                    this.$swal({
                        type: "error",
                        title: "Não podemos continuar!",
                        text: "O paciente não pode ser de município diferente da unidade solicitante"
                    });
                    return false;
                }
                this.dados.dados_recuperados = true;
                this.$store.state.solicitacao.dadosResolucao = this.dados;
                this.$router.push("/atendimentos/solicitacao/resolucao");
            } else {
                this.$swal({
                    type: "error",
                    title: "Informações pendentes",
                    text: "Preencha corretamente os campos destacados em vermelho!"
                });
            }
        },
        limparProcedimentos() {
            if (!this.dados.dados_recuperados) {
                this.dados.procedimentos = [];
                this.$nextTick(() => {
                    this.focoPaciente();
                });
            } else {
                this.$refs.selectUnidade.$el.querySelector("input").blur();
            }
            this.$store.state.solicitacao.dadosResolucao = null;
            this.dados.dados_recuperados = false;
        },
        getDistribuicoes() {
            axios
                .get(`${this.$store.state.serverURI}/api/distribuicao/getUltimas`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.distribuicoes = response.data;

                    if (this.$store.state.solicitacao.ultimaDistribuicaoSelecionada) {
                        this.distribuicaoId = this.$store.state.solicitacao.ultimaDistribuicaoSelecionada;
                    } else {
                        this.distribuicaoId = this.distribuicoes[0].id;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getContratos() {
            axios
                .get(`${this.$store.state.serverURI}/api/distribuicao/contratos/getAllPaginate?distribuicao_id=${this.distribuicaoId}&tipo=0&paginate=false&coluna=nome&ordem=asc`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.unidades = response.data;
                    if (this.$store.state.solicitacao.ultimoContratoSolicitanteSelecionado) {
                        this.contratoSolicitanteSelecionado = this.$store.state.solicitacao.ultimoContratoSolicitanteSelecionado;
                        this.dados.unidadeSolicitante = this.contratoSolicitanteSelecionado.unidade.id;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        setPacienteSelecionado(paciente) {
            this.dados.paciente = paciente;
            this.showTextDangerPaciente = false;
            if (this.dados.paciente.id) {
                this.getNaoRealizados();
                // this.$refs.btnProfissional.abrirModal();
            }
            // if (paciente.id) {
            //     this.$refs.historicos.getHistorico();
            //     this.$refs.historicos.getHistoricoAntigo();
            // }
        },
        setProfissionalSelecionado(profissional) {
            this.dados.profissionalSolicitante = profissional;
            this.showTextDangerProfissional = false;
            this.mostrarModalProcedimento();
        },
        incluirProcedimentoSelecionado(contratoProcedimento) {
            this.contratoProcedimentoTemp = contratoProcedimento;
            this.showModalQuantidadeProcedimentos = true;
        },
        addProcedimentoSelecionado(contratoProcedimento) {
            // if (!this.dados.procedimentos.includes(contratoProcedimento)) {
            if (this.dados.procedimentos.filter(e => e.id == contratoProcedimento.id).length == 0) {
                this.dados.procedimentos.push(contratoProcedimento);
                this.showTextDangerProcedimento = false;
                this.$swal({
                    type: "success",
                    title: "Procedimento adicionado com sucesso!",
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                this.$swal({
                    type: "error",
                    title: "Procedimento duplicado",
                    text: "Este procedimento já foi adicionado!",
                    showConfirmButton: true
                });
            }
            this.showModalQuantidadeProcedimentos = false;
        },
        addDiagnosticoSelecionado(diagnostico) {
            if (!this.dados.diagnosticos.includes(diagnostico)) {
                this.dados.diagnosticos.push(diagnostico);
                this.$swal({
                    type: "success",
                    title: "Diagnostico adicionado com sucesso!",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.showModalAddDiagnosticos = false;
            } else {
                this.$swal({
                    type: "error",
                    title: "Diagnóstico duplicado",
                    text: "Este diagnóstico já foi adicionado!",
                    showConfirmButton: true
                });
            }
        },
        removerProcedimento(index) {
            this.$swal({
                title: "Remover este procedimento da solicitação?",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    if (index > -1) {
                        this.dados.procedimentos.splice(index, 1);
                    }
                }
            });
        },
        removerDiagnostico(index) {
            this.$swal({
                title: "Remover este diagnostico da solicitação?",
                type: "question",

                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    if (index > -1) {
                        this.dados.diagnosticos.splice(index, 1);
                    }
                }
            });
        },
        mostrarModalProcedimento() {
            if (this.isEmpty(this.dados.paciente) && this.isEmpty(this.dados.profissionalSolicitante)) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o paciente e o profissional!",
                    showConfirmButton: true
                });
                return;
            }
            if (this.isEmpty(this.dados.paciente)) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o paciente!",
                    showConfirmButton: true
                });
                return;
            }
            if (this.isEmpty(this.dados.profissionalSolicitante)) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar o profissional!",
                    showConfirmButton: true
                });
                return;
            }

            this.showModalAddProcedimentos = true;
        },
        isEmpty(objeto) {
            return Object.values(objeto).every(valor => valor === "");
        },
        focoUnidades() {
            // this.$refs.selectUnidade.$refs.input.focus();
            this.$refs.selectUnidade.$el.querySelector("input").focus();
        },
        focoPaciente() {
            // this.$refs.btnPaciente.getDataTable();
            this.$refs.btnPaciente.abrirModal();
        },
        focoDiagnostico() {
            this.$nextTick(function() {
                this.$refs.btnAdicionarDiagnostico.focus();
            });
        }
    },
    updated: function() {
        this.$nextTick(function() {
            if (this.focusAdicionarDiagnositico == true) {
                this.$refs.btnAdicionarDiagnostico.focus();
                this.focusAdicionarDiagnositico = false;
            }
        });
    },
    watch: {
        contratoSolicitanteSelecionado: function(val) {
            if (val) {
                this.dados.unidadeSolicitante = val.unidade.id;
            }
            this.$store.state.solicitacao.ultimoContratoSolicitanteSelecionado = val;
        },
        distribuicaoId: function(val) {
            if (val) {
				this.$store.state.solicitacao.ultimaDistribuicaoSelecionada = val;
                this.getContratos();
            }
        }
    }
};
</script>

<style scoped>
/* .altura-hostorico {
					height: 300px;
					overflow-y: auto;
				} */

.erro-validacao {
    color: #d73925;
}
</style>



// WEBPACK FOOTER //
// index.vue?0f3f2592